import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { RootState } from "../store"
import { CartolaDepartment, CartolaDepartmentInit } from "../../types/slices/cartolaDepartmentType"

const initialState: CartolaDepartmentInit =
{
    status: ApiStatus.FETCHED,
    cartolaDepartments: [],
    totalRows: 0,
    errorMessage: undefined,
    selectedCartolaDepartment: undefined,
}

const cartolaDepartmentSlice = createSlice({
    name: 'cartolaDepartmentSlice',
    initialState,
    reducers: {
        onFetchCartolaDepartments(state, { payload }: { payload: CartolaDepartment[] }) {
            state.status = ApiStatus.FETCHED
            state.cartolaDepartments = payload
            state.errorMessage = undefined
        },
        onSetTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onSetSelectedCartolaDepartment(state, { payload }: { payload: CartolaDepartment | undefined }) {
            state.selectedCartolaDepartment = payload
        },
    }
})

export const cartolaDepartmentState = (state: RootState) => state.cartolaDepartmentSlice
export default cartolaDepartmentSlice.reducer

export const {
    onFetchCartolaDepartments,
    changeStatus,
    onSetSelectedCartolaDepartment,
    onSetTotalRows
} = cartolaDepartmentSlice.actions